import requestJWT from "utils/requestJWT";
import request from "utils/request";

const getScheduleApi = async (id) => {
    return await request.get(`/schedule/${id}/get-by-tour`);
};

const createScheduleApi = async (data) => {
    return await requestJWT.post(`/schedule/create`, data);
};

const updateScheduleApi = async (id, data) => {
    return await requestJWT.put(`/schedule/${id}/update`, data);
};

const deleteScheduleApi = async (id) => {
    return await requestJWT.delete(`/schedule/${id}/remove`);
};

export {
    getScheduleApi,
    createScheduleApi,
    updateScheduleApi,
    deleteScheduleApi,
};
